/* eslint-disable import/prefer-default-export */
import { theme } from '@fortressiq/fiq-ds'

export const selectStyles = { menu: { zIndex: theme['z-base-above'] } }
